const t = {
  name: "Education",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 1.7981L22.8028 8.99995L22 9.53516V15.9999H20V10.8685L19 11.5352V14.9999C19 18.8622 15.8623 21.9999 12 21.9999C8.13772 21.9999 5 18.8622 5 14.9999V11.5351L1.19727 8.99995L12 1.7981ZM7 12.8684V14.9999C7 17.7577 9.24228 19.9999 12 19.9999C14.7577 19.9999 17 17.7577 17 14.9999V12.8685L12 16.2018L7 12.8684ZM4.80282 8.99995L12 13.7981L19.1973 8.99995L12 4.2018L4.80282 8.99995Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Education
};
